// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';
import { OnDestroy, OnInit, computed, signal, ViewChild, TemplateRef } from "@angular/core";
import {
  Item,
  date,
  errorMessage,
  items,
  status,
  tone,
} from "../../libs/infra";

import { apacheDomainRows, normalizeDomain } from "../../libs/apache";
const wiz = new Wiz({ appId: 'component.apache', namespace: 'apache' });
@AngularComponent({
  selector: 'wiz-apache-host',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class ComponentApacheComponent implements OnInit, OnDestroy {
  @ViewChild('feedback', {static:true}) public feedback?: TemplateRef<unknown>;
  public loading = signal(true);
  public busy = signal(false);
  public error = signal("");
  public host = signal<Item>({});
  public records = signal<Item[]>([]);
  public certificates = signal<Item[]>([]);
  public operation = signal<Item | null>(null);
  public resultVisible = signal(true);
  public versionResult = "";
  public search = signal("");
  public tlsLoading = signal(false);
  public tlsDetails = signal<Item[]>([]);
  public tlsDomain = "";
  private tlsRequest = 0;
  public get filteredSites(): Item[] { return this.sites.filter(site => this.matchesSearch(site)); }
  public get filteredDomains(): Item[] { return this.domainRows().filter(row => String(row["domain"]).toLowerCase().includes(this.search().trim().toLowerCase()) || row["sites"].some((site: Item) => String(site["name"]).toLowerCase().includes(this.search().trim().toLowerCase()))); }
  private matchesSearch(site: Item): boolean {
    const query = this.search().trim().toLowerCase();
    return [site["name"], ...(site["domains"] || [])].some(value => String(value).toLowerCase().includes(query));
  }
  public fullDate(value: string): string {
    return value ? new Intl.DateTimeFormat("ko-KR", {dateStyle:"medium",timeStyle:"long",timeZone:"Asia/Seoul"}).format(new Date(value)) : "—";
  }
  public async openTls(row: Item): Promise<void> {
    this.tlsDomain = row["domain"];
    this.tlsDetails.set([]); this.error.set(""); this.modal.set("tls"); this.tlsLoading.set(true);
    const request = ++this.tlsRequest;
    const details = await Promise.all(row["tlsSites"].map(async (site: Item) => {
      try {
        const detail = await wiz.api.get<Item>("/apache/sites/" + encodeURIComponent(site["name"]) + "/tls");
        return { ...detail, certificates: (detail["certificates"] || []).filter((cert: Item) => cert["domains"].some((domain: string) => normalizeDomain(domain) === normalizeDomain(row["domain"]))) };
      } catch (error) { return {name:site["name"], certificates:[], message:errorMessage(error)}; }
    }));
    if (request !== this.tlsRequest || this.destroyed) return;
    this.tlsDetails.set(details); this.tlsLoading.set(false);
  }
  public issueDomain = "";
  private operationAction = "";
  public selected = signal<Item | null>(null);
  public modal = signal("");
  public agentJob = signal<Item | null>(null);
  public content = "";
  public fileName = "";
  public email = "";
  public issueRecordId = "";
  public aiPrompt = "";
  public aiAssistVisible = signal(false);
  public mode: "domain" | "raw" = "domain";
  public date = date;
  public status = status;
  public tone = tone;
  public pendingAction = "";
  private poll: any;
  private destroyed = false;

  public ngOnInit(): void {
    void this.load();
  }
  public ngOnDestroy(): void {
    this.destroyed = true;
    clearTimeout(this.poll);
  }
  public async load(refresh = false): Promise<void> {
    this.loading.set(true);
    this.error.set("");
    try {
      const [host, certificates, zones] = await Promise.all([
        wiz.api.get<Item>("/apache?refresh=" + refresh),
        wiz.api.get("/certificates"),
        wiz.api.get("/dns/zones?size=100"),
      ]);
      this.host.set(host);
      this.certificates.set(items(certificates));
      const records = (
        await Promise.all(
          items(zones).map((zone) =>
            wiz.api.get("/dns/zones/" + zone["id"] + "/records?size=100"),
          ),
        )
      ).flatMap(items);
      this.records.set(
        records.filter(
          (record) =>
            record["managed"] &&
            ["A", "AAAA", "CNAME"].includes(record["type"]) &&
            !String(record["name"]).includes("*"),
        ),
      );
    } catch (error) {
      this.error.set(errorMessage(error));
    } finally {
      this.loading.set(false);
    }
  }
  public get sites(): Item[] {
    return this.host()["sites"] || [];
  }
  public domainRows = computed(() => apacheDomainRows(this.sites, this.certificates(), this.records()));
  public recordFor(domain: string): Item | null {
    return this.records().find((record) => normalizeDomain(record["name"]) === normalizeDomain(domain)) || null;
  }
  public openCreate(): void {
    this.selected.set(null);
    this.fileName = "docker-infra-" + Date.now() + ".conf";
    this.content =
      "<VirtualHost *:80>\n    ServerName example.com\n    DocumentRoot /var/www/html\n</VirtualHost>\n";
    this.aiPrompt = "";
    this.aiAssistVisible.set(false);
    this.error.set("");
    this.agentJob.set(null);
    this.modal.set("editor");
  }
  public async openSite(site: Item): Promise<void> {
    if (this.busy() || site["problem"]) return;
    this.busy.set(true);
    this.error.set("");
    try {
      const selected = await wiz.api.get<Item>(
        "/apache/sites/" + encodeURIComponent(site["name"]),
      );
      this.selected.set({ ...selected, editable: site["editable"] });
      this.fileName = String(site["name"]);
      this.content = String(selected["content"] || "");
      this.aiPrompt = "";
      this.aiAssistVisible.set(false);
      this.agentJob.set(null);
      this.modal.set("editor");
    } catch (error) {
      this.error.set(errorMessage(error));
    } finally {
      this.busy.set(false);
    }
  }
  public closeModal(): void {
    if (this.busy()) return;
    this.tlsRequest++;
    this.tlsLoading.set(false);
    this.modal.set("");
    this.pendingAction = "";
    this.aiPrompt = "";
    this.aiAssistVisible.set(false);
  }
  public async saveSite(): Promise<void> {
    const selected = this.selected();
    if (selected && !selected["editable"]) return;
    if (!this.fileName.trim() || !this.content.trim()) {
      this.error.set("설정 파일 이름과 내용을 입력하세요.");
      return;
    }
    await this.start(
      selected
        ? "/apache/sites/" + encodeURIComponent(selected["name"])
        : "/apache/sites",
      selected
        ? { content: this.content, revision: selected["revision"] }
        : { name: this.fileName, content: this.content },
      selected ? "PUT" : "POST",
    );
  }
  public confirmAction(action: string): void {
    this.pendingAction = action;
    this.modal.set("confirm");
  }
  public async action(action: string): Promise<void> {
    if (this.busy()) return;
    this.operationAction = action;
    this.modal.set("");
    await this.start("/apache/actions/" + action, {});
  }
  public openCertificate(row: Item): void {
    const record = row["record"] || this.recordFor(row["domain"]);
    const certificate = row["certificate"];
    if (!certificate && row["tlsSites"]?.length) {
      void this.openSite(row["tlsSites"][0]);
      return;
    }
    if (certificate) {
      void this.renew(certificate);
      return;
    }
    if (!record) {
      this.error.set("같은 도메인의 관리 DNS 레코드를 먼저 연결하세요.");
      return;
    }
    this.issueRecordId = record["id"];
    this.issueDomain = String(row["domain"]);
    this.email = "";
    this.error.set("");
    this.modal.set("certificate");
  }
  public async issue(): Promise<void> {
    if (!this.issueRecordId || !this.email) {
      this.error.set("인증서 알림 이메일을 입력하세요.");
      return;
    }
    this.modal.set("");
    await this.start("/certificates/issue", {
      recordId: this.issueRecordId,
      email: this.email,
    });
  }
  public async renew(certificate: Item): Promise<void> {
    await this.start("/certificates/" + certificate["id"] + "/renew", {});
  }
  public async assist(): Promise<void> {
    if (this.busy() || (!!this.selected() && !this.selected()!["editable"])) return;
    if (!this.aiPrompt.trim()) {
      this.error.set("AI에 요청할 내용을 입력하세요.");
      return;
    }
    this.busy.set(true);
    this.error.set("");
    try {
      const job = await wiz.api.post<Item>("/agent/apache-assist", {
        prompt: this.aiPrompt,
        fileName: this.fileName,
        content: this.content,
      });
      this.agentJob.set(job);
      this.pollAgent(job["id"]);
    } catch (error) {
      this.error.set(errorMessage(error));
      this.busy.set(false);
    }
  }
  private pollAgent(id: string): void {
    clearTimeout(this.poll);
    this.poll = setTimeout(async () => {
      if (this.destroyed) return;
      try {
        const job = await wiz.api.get<Item>("/agent/jobs/" + id);
        this.agentJob.set(job);
        if (["succeeded", "failed", "canceled"].includes(job["status"])) {
          this.busy.set(false);
          if (job["status"] === "succeeded") {
            const message = [...(job["messages"] || [])]
              .reverse()
              .find((item: Item) => item["role"] === "assistant");
            if (message) {
              const text = String(message["text"] || "");
              const start = text.indexOf("{");
              try {
                const result = JSON.parse(
                  start >= 0 ? text.slice(start) : text,
                );
                if (result.templateDocument)
                  this.content = result.templateDocument;
                if (result.message) this.error.set(result.message);
              } catch {
                this.error.set("AI 응답을 설정 원문으로 변환하지 못했습니다.");
              }
            }
          }
          return;
        }
        this.pollAgent(id);
      } catch (error) {
        this.error.set(errorMessage(error));
        this.busy.set(false);
      }
    }, 800);
  }
  private async start(
    endpoint: string,
    body: Item,
    method = "POST",
  ): Promise<void> {
    if (this.busy()) return;
    this.busy.set(true);
    this.error.set("");
    try {
      if (!endpoint.startsWith("/apache/actions/")) this.operationAction = "";
      this.operation.set(await wiz.api.request<Item>(method, endpoint, body));
      this.resultVisible.set(true);
      this.modal.set("");
      this.watch();
    } catch (error) {
      this.error.set(errorMessage(error));
      this.busy.set(false);
    }
  }
  private watch(): void {
    clearTimeout(this.poll);
    this.poll = setTimeout(async () => {
      if (this.destroyed) return;
      try {
        const operation = await wiz.api.get<Item>(
          "/operations/" + this.operation()!["id"],
        );
        this.operation.set(operation);
        if (["succeeded", "failed", "canceled"].includes(operation["status"])) {
          this.busy.set(false);
          if (operation["status"] === "succeeded") {
            if (this.operationAction === "version") {
              this.versionResult = String(operation["message"] || "");
              if (/^업데이트 가능: /m.test(this.versionResult)) this.confirmAction("update");
            } else await this.load(true);
          }
          return;
        }
        this.watch();
      } catch (error) {
        this.error.set(errorMessage(error));
        this.busy.set(false);
      }
    }, 1200);
  }
}

export default ComponentApacheComponent;
